import React from 'react';
import { Card } from 'semantic-ui-react';
import { CardComposer } from '../cards/CardComposer';
import { CardProfile } from '../cards/CardProfile';
import { CardSong } from '../cards/CardSong';
import { CardSongCycle } from '../cards/CardSongCycle';
import { CardPlace } from '../cards/CardPlace';
import { CardTextAuthor } from '../cards/CardTextAuthor';

export const Result = ({ data, alias }) => {
  let out = (<React.Fragment />);
  switch (alias) {
    case 'songs':
      return (<CardSong data={data._source} id={data._source.id} />);
    case 'song_cycles':
      return (<CardSongCycle data={data._source} id={data._source.id} />);
    case 'pitches':
    case 'instruments':
    case 'places':
      return (<CardPlace data={data._source} id={data._source.id} />);
    case 'composers':
      return (<CardComposer data={data._source} id={data._source.id} />);
    case 'profiles':
      return (<CardProfile data={data._source} id={data._source.id} />);
    case 'arrangers':
    case 'text_authors': 
      return (<CardTextAuthor data={data._source} id={data._source.id} />);
    case 'instrument_kinds':
      break;
  }
  return out;
};